//Sort of mimics a row in one of the input tables from the iPad app
import { useTranslation } from "react-i18next";

const InputRow = ({
    label,
    children,
    presetValues = undefined,
    onPresetSelected = undefined,
    rest,
}) => {
    const { t } = useTranslation();

    const presetSelect = (e) => {
        if (e.target.selectedIndex == 0) return;

        onPresetSelected(e.target.value);

        // set selected to none
        e.target.selectedIndex = 0;
    };

    return (
        <div className={"form-input-area__input-row"}>
            {label && <h3>{label}</h3>}
            <div>
                {children}
                {presetValues && (
                    <select
                        onChange={presetSelect}
                        style={{
                            maxWidth: "100%",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                        }}
                    >
                        <option value="">{t("Presets...")}</option>
                        {presetValues.map((preset, index) => (
                            <option key={index} value={preset}>
                                {preset}
                            </option>
                        ))}
                    </select>
                )}
            </div>
        </div>
    );
};

export default InputRow;
